// Token storage utilities — single source of truth for the localStorage keys
// the app reads/writes.

import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from './constants'

export { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY }

export const tokenStorage = {
  getAccessToken: () => localStorage.getItem(ACCESS_TOKEN_KEY),
  setAccessToken: (token) => localStorage.setItem(ACCESS_TOKEN_KEY, token),
  getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),
  setRefreshToken: (token) => localStorage.setItem(REFRESH_TOKEN_KEY, token),
  clearTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },
}
